//
// Generated class BankMovementDocumentLink
//

/// <reference path="BankMovementDocumentLink_ManagedObject.ts" />

class BankMovementDocumentLink extends BankMovementDocumentLink_ManagedObject
{

}
